
   <div style="padding: 16px; border-radius: 10px; background: #fff; box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      <mat-card-title class="fs-5 mb-0"> {{'dashboard.latest_messages' | translate}} </mat-card-title>
      <button
        mat-button
        color="primary"
      (click)="seeallmsgs()"
      *ngIf="chatThreads.length>0 && chatThreads.length > 10"
      >
      {{'dashboard.see_more' | translate}}
      </button>
    </mat-card-header>
     <mat-dialog-content >
      <div class="row" *ngIf="chatThreads.length>0">
          <div class="col-sm-12" *ngFor="let item of chatThreads">
              <div class="fl_orders" >
                  <div class="top_section_order">
                      <div class="row">
                          <div class="col-sm-1">
                              <div class="ads_sec">
                                  <div class="hm_icon_progr" >
                                      <img [src]="item.senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" *ngIf="item.isSender == 0">
                                      <img [src]="item.receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" *ngIf="item.isSender == 1">
                                  </div>
                              
                              </div>
                          </div>
                          <div class="col-sm-11" style="padding-left: 22px;">
                              <div class="order_dec">
                                
                                  <div class="tick_opklads">
                                      <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                      <!-- <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon -->
                                        {{item.lastMessageTime | date:'d MMM y, h:mm a':'UTC+0530'}}
              
                                  </div>
                                  <h3 style="-webkit-box-orient: vertical;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 1;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  white-space: normal;
                                  margin-bottom: 8px;
                                  " *ngIf="item.isSender == 0">{{item.senderInfo.name }} (with {{item.entity_name}})</h3>
                                  <h3 style="-webkit-box-orient: vertical;
                                  display: -webkit-box;
                                  -webkit-line-clamp: 1;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  white-space: normal;
                                  margin-bottom: 8px;
                                  " *ngIf="item.isSender == 1">{{item.receiverInfo.name}} (with {{item.entity_name}})</h3>
                                  <p>{{
                                    item.lastMessage
                                  }}
                                  <!-- </p>
                                  <p>Home: Rs.{{item.home_rate}}, Shop: Rs.{{item.shop_rate}}
                                  </p>
                                  <p>Approx Time: {{item.approxTime}} minutes
                                  </p> -->
                                  <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                  <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                               </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          
  
          
  
      </div>
      <div class="row" *ngIf="chatThreads.length == 0">
        <div class="col-sm-12" >
          <div style="padding: 20px 18px 20px 18px;
          background: var(--color-primary-contrast);
          border-radius: var(--dra-radius-x-small);
          cursor: pointer;
          transition: 0.3s;">
            <div class="top_section_order">
              <div class="row">
                <div style="text-align: center;min-height: 200px;
                padding-top: 40px;">
                <div>
                  <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.5 8.5L14.5 13.5M14.5 8.5L9.5 13.5M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>
                  <p style="color: var(--color-primary-light);margin-top: 20px;">No messages to show</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
   </div>
   